import React, { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import CalendarFilter from '../../../ui/calendarFilter';
import { GET_APPT_TYPES_CONFIG } from 'api/graphql/v2/queries/AppointmentTypes';
import { ICalendarFilterOption } from 'model/calendar/filters';
import { IAppointmentType } from 'model/v2';
import { EVENT_TYPES } from 'utils/constants/appointmentsTypes';
import {
  TIME_OFF_APPOINTMENT_TYPE_TITLES,
  TIME_OFF_TYPE_DISPLAY_LABELS
} from 'utils/constants/calendarFilters';

interface Props {
  handleSearchedValues: (
    list: ICalendarFilterOption[],
    checkedList: ICalendarFilterOption[]
  ) => ICalendarFilterOption[];
  setHasData: Dispatch<SetStateAction<boolean>>;
  collapsible?: boolean;
  checkedTimeOffTypes: ICalendarFilterOption[];
  setCheckedTimeOffTypes: Dispatch<SetStateAction<ICalendarFilterOption[]>>;
}

const TimeOffFilter = ({
  handleSearchedValues,
  checkedTimeOffTypes,
  setCheckedTimeOffTypes,
  setHasData,
  collapsible
}: Props) => {
  const { data } = useQuery(GET_APPT_TYPES_CONFIG, {
    variables: { eventType: EVENT_TYPES.Admin, isActive: true }
  });

  const timeOffTypes: ICalendarFilterOption[] = useMemo(() => {
    const adminTypes: IAppointmentType[] = data?.appointmentTypesConfig || [];
    return adminTypes
      .filter(type =>
        TIME_OFF_APPOINTMENT_TYPE_TITLES.includes(type.title || '')
      )
      .sort(
        (a, b) =>
          TIME_OFF_APPOINTMENT_TYPE_TITLES.indexOf(a.title || '') -
          TIME_OFF_APPOINTMENT_TYPE_TITLES.indexOf(b.title || '')
      )
      .map(type => ({
        label: TIME_OFF_TYPE_DISPLAY_LABELS[type.title!] || type.title!,
        value: String(type.id)
      }));
  }, [data]);

  const searchedTimeOffTypes = useMemo(() => {
    return handleSearchedValues(timeOffTypes, checkedTimeOffTypes);
  }, [handleSearchedValues, timeOffTypes, checkedTimeOffTypes]);

  useEffect(() => {
    searchedTimeOffTypes?.length === 0 ? setHasData(false) : setHasData(true);
  }, [searchedTimeOffTypes, setHasData]);

  return (
    <>
      <CalendarFilter
        setCheckedList={setCheckedTimeOffTypes}
        checkedList={checkedTimeOffTypes}
        listOptions={searchedTimeOffTypes}
        length={timeOffTypes.length}
        title="Time Off"
        collapsible={collapsible}
        subtitle="Show only providers who are out on the visible day/week."
      />
    </>
  );
};
export default React.memo(TimeOffFilter);
